import { AxiosRequestConfig } from 'axios';
import moment from 'moment';

import { store } from '@/Root';

import { getUserFromLocalStorage } from '@/utils/user';
import { authOperations } from '@/state/ducks/auth';

const refreshTokenInterceptor = async (config: AxiosRequestConfig) => {
  const splittedUrl = config?.url?.split('/');

  if (splittedUrl) {
    const last = splittedUrl[splittedUrl.length - 1];

    if (last === 'matrices' && config.method === 'post') {
      return config;
    }
    if (last === 'password-recovery' && config.method === 'patch') {
      return config;
    }

    const ms = splittedUrl[0];

    if (ms && ms === 'zipcode') {
      return config;
    }
  }

  const hasToken = !!config.headers['Authorization'];

  if (hasToken) {
    const user = getUserFromLocalStorage();

    if (!user) {
      console.error('Usuário não autenticado, erro no interceptor'); // eslint-disable-line
    }

    const now = moment();
    const expiration = moment(user.userExpiration);

    const minutesToExpire = moment.duration(expiration.diff(now)).asMinutes();

    if (!minutesToExpire || minutesToExpire < 10) {
      await store.dispatch(authOperations.handleRefreshToken());
    }
  }

  return config;
};

export default refreshTokenInterceptor;
